'use strict';

let DomUtils = {
  createElementsFromString(str) {
    let div = document.createElement('div');
    div.innerHTML = str.trim();
    return div.childNodes;
  },

  removeAllChildren(node) {
    while (node.hasChildNodes()) {
      node.removeChild(node.lastChild);
    }
  },
  getTextFromNode,

  createDomNode : function(html) {
    let children = this.createElementsFromString(html);
    return {
      appendTo: function(destination) {
        for (let child of children) {
          destination.appendChild(child);
        }
      }
    };
  },

  removeChildIfPresent: function(parent, cssSelector) {
    var element = parent.querySelector(cssSelector);
    if (element) {
      element.parentNode.removeChild(element);
    }
  },

  removeElement: function(element) {
    element.parentNode.removeChild(element);
  },

  hasClass: function(el, name) {
    return new RegExp('(\\s|^)'+name+'(\\s|$)').test(el.className);
  },

  addClass: function(el, name){
    if (!this.hasClass(el, name)){
      el.className += (el.className ? ' ' : '') +name;
    }
  },

  removeClass: function(el, name){
    if (this.hasClass(el, name)){
      el.className = el.className.replace(new RegExp('(\\s|^)'+name+'(\\s|$)'),' ').replace(/^\s+|\s+$/g, '');
    }
  },

  isTouchDevice: function() {
    return 'ontouchstart' in window || navigator.msMaxTouchPoints;
  },

  createEvent: function (options) {
    let event;
    const {eventName, element, payload} = options

    try {
      // Works in modern browsers
      event = new CustomEvent(eventName, { detail: payload });
    }
    catch(err) {
      // Works in Internet Explorer (all versions)
      event = document.createEvent("CustomEvent");
      event.initCustomEvent(eventName, false, false,  options);
    }

    return {
      dispatch: function() {
        element.dispatchEvent(event);
      }
    }
  }

};

function getTextFromNode(node, addSpaces) {
  var result = '';
  for (let i = 0; i < node.childNodes.length; i++) {
    let child = node.childNodes[i];
    let text = null;
    if (child.nodeType === 1) {
      text = getTextFromNode(child, addSpaces);
    } else if (child.nodeType === 3) {
      text = child.nodeValue;
    }
    if (text) {
      if (addSpaces && doesNotEndWithSpace(result) && doesNotStartWithSpace(text)) {
        text = ' ' + text;
      }
      result += text;
    }
  }
  return result;

  function doesNotStartWithSpace(str) {
    return /^\S/.test(str);
  }
  function doesNotEndWithSpace(str) {
    return /\S$/.test(str);
  }
}



export default DomUtils;
